export const GetURLDetails = (url?: string | null) => {

    const urlValue: string = url ? url : window.location.href;
    const urlObject: URL = new URL(urlValue);

    const URLDetails = {
        href: urlObject.href,
        protocol: urlObject.protocol,
        host: urlObject.host,
        hostname: urlObject.hostname,
        port: urlObject.port,
        pathname: urlObject.pathname,
        search: urlObject.search,
        hash: urlObject.hash,
    };

    const moduleNames = {
        '/refer': 'refer_a_client',
        '/register_client': 'register_a_client',
        '/register': 'become_a_partner',
        '/login': 'login',
        '/account': 'account',
        '/resources': 'resources',
        '/referrals': 'referrals_activity',
        '/commissions': 'commissions',
        '/invoices': 'invoices',
        '/settings': 'settings',
        '/resetpassword': 'reset_password',
        '/createpassword': 'create_password',
        '/approvePartner': 'approve_partner'
    }

    const currentModuleKey: string = Object.keys(moduleNames).find((key: string) => URLDetails.pathname.includes(key)) || '';
    const currentModule: string = moduleNames[currentModuleKey] || '';

    const isReferAClientModule: boolean = currentModule === 'refer_a_client';
    const isBecomeAPartnerModule: boolean = currentModule === 'become_a_partner';
    const isRegisterAClient: boolean = currentModule === 'register_a_client';
    const isLoginModule: boolean = currentModule === 'login';
    const isAccountModule: boolean = currentModule === 'account';
    const isResourcesModule: boolean = currentModule === 'resources';
    const isReferralsActivity: boolean = currentModule === 'referrals_activity';
    const isCommissionModule: boolean = currentModule === 'commissions';
    const isInvoiceModule: boolean = currentModule === 'invoices';
    const isSettingModule: boolean = currentModule === 'settings';
    const isResetPassword: boolean = currentModule === 'reset_password';
    const isCreatePassword: boolean = currentModule === 'create_password';
    const isApprovePartner: boolean = currentModule === 'approve_partner';

    return {
        URLDetails,
        currentModule,
        isReferAClientModule,
        isBecomeAPartnerModule,
        isRegisterAClient,
        isLoginModule,
        isResourcesModule,
        isAccountModule,
        isReferralsActivity,
        isCommissionModule,
        isInvoiceModule,
        isSettingModule,
        isResetPassword,
        isCreatePassword,
        isApprovePartner
    }
}